import { usePermissionCheck } from '../permissions'
import { type UserId } from '@terros/common'

type CanManageUserResult = {
  canManage: boolean
  isLoading: boolean
}

export function useCanManageUser(userId: UserId | undefined): CanManageUserResult {
  const { data, isLoading } = usePermissionCheck({ permissionType: 'user:manage', targetId: userId })
  if (!userId) return { canManage: true, isLoading: false }
  return { canManage: data ?? false, isLoading }
}

type CanUpdateUserResult = {
  canUpdate: boolean
  isLoading: boolean
}
export function useCanUpdateUser(userId: UserId | undefined): CanUpdateUserResult {
  const { data, isLoading } = usePermissionCheck({ permissionType: 'user:update', targetId: userId })
  if (!userId) return { canUpdate: true, isLoading: false }
  return { canUpdate: data ?? false, isLoading }
}
